import type { HTMLProps } from "react";

const Close = (props: HTMLProps<SVGSVGElement>) => {
  return (
    <svg
      {...props}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 10L10 22M22 22L10 10"
        stroke="#0E0E0E"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default Close;
